import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dot",
  "use": "icon-dot-usage",
  "viewBox": "0 0 6 7",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 7\" id=\"icon-dot\"><circle cx=\"3\" cy=\"3.5\" r=\"3\" fill=\"#FA6400\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol